import { render, staticRenderFns } from "./MspRisultatoDetail.vue?vue&type=template&id=5290c958"
import script from "./MspRisultatoDetail.vue?vue&type=script&lang=js"
export * from "./MspRisultatoDetail.vue?vue&type=script&lang=js"
import style0 from "./MspRisultatoDetail.vue?vue&type=style&index=0&id=5290c958&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports